import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import './_styles_/AuctionProgressBar.css';
import { date } from '../../utils';
import { auctionType } from '../../types';

export const calcProgressInPercent = (currentMoment, openingMoment, onePercentOfRange) => {
    const currentMomentInUtc = currentMoment.utc();
    const openingMomentInUtc = openingMoment.utc();
    const progressInMilis = currentMomentInUtc.diff(openingMomentInUtc);
    return Math.round(progressInMilis / onePercentOfRange);
};

AuctionProgressBar.propTypes = {
    auction: auctionType.isRequired,
    onProgress: PropTypes.func.isRequired,
};

function AuctionProgressBar(props) {
    const {
        auction,
        onProgress,
    } = props;
    const openingMoment = moment(auction.openingTime);
    const closureMoment = moment(auction.closureTime);
    const maxRange = closureMoment.diff(openingMoment);
    const onePercentOfRange = maxRange / 100;
    const [progress, setProgress] = useState(0);
    useEffect(() => {
        const progressInterval = setInterval(() => {
            const recalculatedProgress = calcProgressInPercent(moment(date()), openingMoment, onePercentOfRange);
            setProgress(recalculatedProgress);
            onProgress(recalculatedProgress);
        }, 2000);
        const newProgress = calcProgressInPercent(moment(date()), openingMoment, onePercentOfRange);
        setProgress(newProgress);
        onProgress(newProgress);
        return () => clearInterval(progressInterval);
    }, [openingMoment, onePercentOfRange, onProgress]);
    const widthStyle = progress ? `${progress}%` : '1px';
    return (
        <div className="auction-header--progress--bar-container--bar" style={{ width: widthStyle }} />
    );
}

export default AuctionProgressBar;
